import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { types } from "../../types/types";

export const getCotizacionesAceptadasMesaEntrada = () => 
    async (dispatch, getState) => {
        dispatch(startSpinner());
        try {
        const { dataContrato } = getState().contrataciones;
        const response = await fetchConToken(`MesaEntrada/Cotizaciones/${dataContrato.idEfectorFacturacion}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.mesaEntradaGetCotizacionesSuccess,
                payload: body,
            });
            dispatch(finishSpinner());
        } else {
            throw body
        }
        } catch (error) {
            dispatch(finishSpinner())
            dispatch({ type: types.mesaEntradaGetCotizacionesError })
            handleErrorApi(dispatch, error, "Error al traer las cotizaciones", "Ha ocurrido un error. Intente nuevamente")
        }
    };